import { DataProvider } from 'react-admin';
import { usersProxy } from './apiGateway';
import type { AiModeration } from './AiModerationResultCard';

type AdStatusInfo = {
    type: string;
    reason?: string | null;
    internalComment?: string | null;
    isFake?: boolean | null;
    orderId?: string | null;
    expertModerationExtraInfo?: {
        photos?: string[];
        userComment?: string | null;
    } | null;
};

type InternalAdInfoResponse = {
    id: string;
    adObjectId?: string;
    createdByUserId: string;
    adInfo: {
        gender: string;
        category: string;
        subcategory: string;
        attachmentPhotos: string[];
        photosId?: string[] | null;
        clothStatus: string;
        brandName: string;
        modelName: string;
        size: string;
        country: string;
        priceInfo: {
            fullPrice: number;
            amountWithoutFee: number;
            feeAmount: number;
            feePercent: number;
        };
        cityInfo: {
            id: string;
            city: string;
            region?: string | null;
        };
        otherPref: {
            isExchange: boolean;
            isVintage: boolean;
            isExistBox: boolean;
            serialNumber?: string | null;
        };
        description: string;
    };
    status: AdStatusInfo;
    statusHistory: AdStatusInfo[];
    hasOriginalLabel: boolean;
    creationDate: string;
    lastUpdateDate: string;
    aiModeration?: AiModeration | null;
    details: {
        serialNumber: number;
        viewsCount: number;
    };
};

export const userAdsDataProvider: DataProvider = {
    getList: () => Promise.reject('Not implemented'),

    getOne: async (_resource, params) => {
        const { id } = params;

        try {
            const adInfo = await usersProxy.getAdInfo(String(id), { source: 'USER_AD_SHOW' });
            if (!adInfo?.id) {
                throw new Error('Ad not found');
            }

            const requestedId = String(id);
            const data: InternalAdInfoResponse = {
                ...adInfo,
                // Для react-admin id ответа должен совпадать с id из URL
                id: requestedId,
                adObjectId: adInfo.id ?? undefined,
            };

            return { data: data as any };
        } catch (error) {
            console.error('Error fetching ad info:', error);
            throw error;
        }
    },

    getMany: () => Promise.reject('Not implemented'),
    getManyReference: () => Promise.reject('Not implemented'),
    create: () => Promise.reject('Not implemented'),
    update: () => Promise.reject('Not implemented'),
    updateMany: () => Promise.reject('Not implemented'),
    delete: () => Promise.reject('Not implemented'),
    deleteMany: () => Promise.reject('Not implemented'),
};
